import type { PropsWithChildren, ReactNode } from 'react';
import { useThemeContext } from '@utils/hooks/use-theme-context';
import {
  WorkspaceDropContext,
  type useWorkspaceDnd
} from './use-workspace-dnd';

type Props = PropsWithChildren<{
  header?: ReactNode;
  dnd: ReturnType<typeof useWorkspaceDnd>;
}>;

export function WorkspaceDropArea({ header, dnd, children }: Props) {
  const { getColour } = useThemeContext();
  return (
    <WorkspaceDropContext.Provider value={dnd.getDropTargetProps}>
      {header}
      {dnd.preview}
      <div className="px-2 sm:px-0 flex-1 min-h-0 flex flex-col">
        {dnd.hint && (
          <div
            role="status"
            aria-live="polite"
            className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] rounded-full shadow-pop border border-hairline px-5 py-3 pointer-events-none"
            style={{
              backgroundColor: getColour('secondLayer'),
              color: getColour('normalText')
            }}
          >
            {dnd.hint}
          </div>
        )}
        {children}
      </div>
    </WorkspaceDropContext.Provider>
  );
}
